import { createBuilder } from '@cld/widget-iframe-creator-core';
import Parent from './Parent';
export const parentBuilder = createBuilder(Parent);

export const createIframe = ({ src, Parent = require('./Parent').default, incomingEvents, outgoingEvents, ...args }) => (initConfig) =>
  Parent({ src, initConfig, incomingEvents, outgoingEvents, ...args });

